import Vue from 'vue';
import * as commonConst from '../common/constants';
import * as reservedInstanceConst from './constants';
import * as servicesApis from '../../services/apis/reservedInstance';

export default {
    [reservedInstanceConst.describeResProduct](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, servicesApis.describeResProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(reservedInstanceConst.describeResProduct, {
                    list: data.data.items,
                    total: data.data.total
                });
                resolve();
            }).catch(e => {
                reject(e);
            })
        });
    },
};
